import { SHAREDCONSTANTS } from './../_constants/constants';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { APPSVIEWLABELS, DETAILSVIEWLABELS, OPCOVIEWLABELS, SEARCHVIEWLABELS, KYCUPDATEVIEWLABELS } from '../_constants/constants';
import { DEFAULT_OPCO, SPAIN, ITALY, GERMANY, UK, DISPLAY_KYC_PERSONAL_IDTYPE } from '../_constants/config';
import { Address, App, KycUpdateData, PersonalId } from '../_models/data.structures';
import { AgentProfileService } from '../_services/agent.profile.service';
import { ConsentService } from './../_services/consent.service';
import { CustomerService } from './../_services/customer.service';
import { RememberMeService } from './../_services/rememberme.service';
import { SuccessfullLoginService } from './../_services/successfull.login.service';
import { SmsURLService } from './../_services/smsurl.service';
import { KYCService } from './../_services/kyc.service';
import { AppDialogComponent } from './consents/app.dialog.component';
import { CustomerUpdateDialogComponent } from './customer-update/customer.update.dialog.component';
import { KycUpdateDialogComponent } from './kyc/kyc.update.dialog.component';
import { MailaddComponent } from './mailadd/mail.add.dialog.component';
import { MailupdateComponent } from './mailupdate/mail.update.dialog.component';

import { MSISDNconfirmComponent } from './msisdnupdate/msisdn.confirm.dialog.component';
import { MobileConnectComponent } from './mobile-connect/mobile.connect.dialog.component';
import { ResetDialogComponent } from '../reset/reset.dialog.component';
import { ResetPinDialogComponent } from '../reset/reset.pin.dialog.component';
import { ActivateAccountDialogComponent } from '../activateaccount/activate.account.dialog.component';
import { UnlockAccountDialogComponent } from '../unlockaccount/unlock.account.dialog.component';

import { RememberMeComponent } from '../rememberme/rememberme.dialog.component';
import { LogoutCustomerComponent } from './logout-customer/logout.customer.dialog.component';
import { GatewayHistoryComponent } from './gateway-history/gateway-history.dialog.component';
import { KYCHistoryDialogComponent } from './kyc/kyc.history.dialog.component';
import { SuccessfullLogin } from './mc-successfull-login/mc.successfull.login.component';


import { DeleteCofirmationDialogComponent } from '../shared/delete-confirmation/delete-confirmation.dialog.component';

import { McConnectService } from './../_services/mcconnect.service';

import { TranslatePipe } from '../shared/translate/translate.pipe';
import { TranslateService } from '../_services/translate.service';
import { LoaderService } from '../_services/loader.service';
import { KYCINFODialogComponent } from './kyc/kyc.informational.dailog.compnent';
import { KycRevokeDialogComponent } from './kyc/kyc.revoke.dialog.component';
import { TimezoneService } from '../_services/timezone.service';
@Component({
  templateUrl: './details.component.html',
  providers: [CustomerService, KYCService, ConsentService, RememberMeService, SuccessfullLoginService, SmsURLService, McConnectService, TranslatePipe,TimezoneService]
})


export class DetailsComponent implements OnInit {
  private static runningRequests = 0;
  private _lock = new Object();
  router: Router;
  ds: DialogService;
  opcoValue: string;
  subValue: string;
  opcoviewlabels = OPCOVIEWLABELS;
  searchviewlabels = SEARCHVIEWLABELS;
  detailsviewlabels = DETAILSVIEWLABELS;
  agentProfileService: AgentProfileService;
  consentService: ConsentService;
  kycService: KYCService;
  customerService: CustomerService;
  rememberMeService: RememberMeService;
  lastLoginService: SuccessfullLoginService;
  smsurlService: SmsURLService;
  mobileconnectService: McConnectService;
  timezoneService:TimezoneService
  singleAppButtonsDisabled = false;
  userconfigfields = DEFAULT_OPCO;
  kycupdateviewlabels = KYCUPDATEVIEWLABELS;
  kycpidtypedisplay = DISPLAY_KYC_PERSONAL_IDTYPE;
  statusRange = [];
  personalTypeRange = [];

  mcconnect:string = "";
  mcconnectStatus:string = "";
  mcconnectLastUpdatedAt:string = "";
  selectedCountry:string = '';
  statusTranslated = [];
  genderTranslated = [];
  idTypeTranslated = [];
  detailData:{};
  entityClass:string;
  
  public static incrementRunningRequests() {
    // TODO: maybe use locks to be sure, that no operation gets lost
    // but ++ and -- should be atomic operations
    this.runningRequests++;
  }
  public static decrementRunningRequests() {
    if (this.runningRequests > 0) {
      this.runningRequests--;
    }
  }

  public isRequestRunning(): boolean {
    return DetailsComponent.runningRequests > 0;
  }

  constructor(ds: DialogService,
    router: Router,
    private route: ActivatedRoute,
    consentService: ConsentService,
    kycService: KYCService,
    customerService: CustomerService,
    rememberMeService: RememberMeService,
    lastLoginService: SuccessfullLoginService,
    smsurlService: SmsURLService,
    agentProfileService: AgentProfileService,
    mobileconnectService: McConnectService,
    timezoneService:TimezoneService,
    private translatePipe: TranslatePipe,
    private translateService: TranslateService,
    private loaderService: LoaderService) {
    this.consentService = consentService;
    this.kycService = kycService;
    this.customerService = customerService;
    this.rememberMeService= rememberMeService;
    this.lastLoginService= lastLoginService;
    this.smsurlService= smsurlService;
    this.mobileconnectService = mobileconnectService;
    this.router = router;
    this.ds = ds;
    this.agentProfileService = agentProfileService;
    this.timezoneService=timezoneService;
    
  }

  
  ngAfterViewChecked() {
    /**
     * Disable all the buttons if user reaches
     * profile page of user who is terminated.
     */
    if (this.customerService.getPerson().status == "TERMINATED" && 
    this.opcoValue =='vo') {
      const detailsId = document.getElementById("detailsCmp");
      const allButtons = detailsId.querySelectorAll('button');
      for(let i=0;i < allButtons.length;i++) {
        allButtons[i].disabled = true;
      }
    }
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.subValue = params['sub'];
      this.opcoValue = params['opco'];
      this.mcconnect = "blocked";
      this.mcconnectStatus = "true";
      this.mcconnectLastUpdatedAt = "";
      this.selectedCountry = params['country'];
      if (this.subValue === undefined && this.subValue.trim() === '') {
        this.router.navigate(['/' + this.opcoValue + '/search']);
      }
      if(this.opcoValue === 'ro'|| this.opcoValue === 'vo' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it'){
          this.customerService.getUserByRequest(this.subValue, this.opcoValue, this.ds, this.selectedCountry);
      }
      else{
        this.customerService.getUserByRequest(this.subValue, this.opcoValue, this.ds, this.selectedCountry);
        this.consentService.getGrantedAppsForCustomer(this.subValue, this.opcoValue, this.selectedCountry);
        this.consentService.getBlacklistedAppsForCustomer(this.subValue, this.opcoValue, this.selectedCountry);
        this.consentService.getBannedAppsForCustomer(this.subValue, this.opcoValue, this.selectedCountry);
      }
    });

        if( this.opcoValue === 'es' ){
            this.userconfigfields = SPAIN;
        }

        else if( this.opcoValue === 'de' ){
            this.userconfigfields = GERMANY;
        }

        else if( this.opcoValue === 'it' ){
            this.userconfigfields = ITALY;
        }

        else if( this.opcoValue === 'gb' ){
            this.userconfigfields = UK;
        }

        for (let i = 0; i < this.kycupdateviewlabels.STATUS_OPTIONS_REAL_VALUES.length; i++) {
          this.statusRange.push(i);
        }

        for (let i = 0; i < this.kycpidtypedisplay.kyc_pid_type_display_name.length; i++) {
          this.personalTypeRange.push(i);
        }

        this.statusTranslated = this.translatePipe.transform("STATUS_OPTIONS_SHOWN_VALUES",'KYCUPDATEVIEWLABELS');
        this.genderTranslated = this.translatePipe.transform("GENDER_OPTIONS",'USERUPDATEVIEWLABELS');
        this.idTypeTranslated = this.translatePipe.transform("ID_TYPE_SHOWN_VALUES",'ID_TYPE');
  }

  showAppDialog(appid: string) {
    DetailsComponent.incrementRunningRequests();
    this.loaderService.display(true);
    let title: string;
    let app: App;
    title = this.translatePipe.transform("SERVICES_SINGLE_APP",'DETAILSVIEWLABELS');
    this.consentService.getApp(appid, this.subValue, this.opcoValue).subscribe(
      data => {
        DetailsComponent.decrementRunningRequests();
        this.loaderService.display(false);
        app = data;
        this.openAppDialog(app);
      },
      err => {
        DetailsComponent.decrementRunningRequests();
        this.loaderService.display(false);
        this.ds.addDialog(NotificationDialogComponent, {
          success: false,
          message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
        });
      }
    );
  }

  openAppDialog(app: App) {
    this.ds.addDialog(AppDialogComponent, {
      title: this.translatePipe.transform("MODAL_TITLE_SINGLE",'APPSVIEWLABELS'),
      app: app,
      agentprofile: this.agentProfileService.loadAgentProfile(),
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      selectedCountry: this.selectedCountry,
      consentService: this.consentService
    });
  }

  showMailupdateDialog(event) {
    this.loseFocusOnButton(event,"btn-mailupdate");    

    this.ds.addDialog(MailupdateComponent, {
      title: 'Mailupdate dialog', 
      oldMail: this.customerService.getPerson().email,
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService
    });
  }

  showMSISDNconfirmDialog(event) {
    this.loseFocusOnButton(event,"btn-msisdnconfirm");    

    this.ds.addDialog(MSISDNconfirmComponent, {
      title: 'Msisdnupdate dialog', oldMsisdn: this.customerService.getPerson().phone_number,
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService,
      smsurlService: this.smsurlService
    });
  }


  showMobileConnectDialog(event) {
    this.loseFocusOnButton(event,"btn-mobileconnect");

    DetailsComponent.incrementRunningRequests();
    this.loaderService.display(true);

    this.mobileconnectService.getMConnectStatus(this.subValue,this.opcoValue).subscribe(
          (data) => {
            this.mcconnect = data.mobileConnect;
            this.mcconnectLastUpdatedAt = JSON.parse(data.lastUpdateTimeMC) || "";
            this.mcconnectStatus = data.mobileConnect;

            this.ds.addDialog(MobileConnectComponent, {
              title: 'MobileConnect dialog',
              subValue: this.subValue,
              opcoValue: this.opcoValue,
              mcconnect:this.mcconnect,
              mcconnectStatus: this.mcconnectStatus,
              mcconnectLastUpdatedAt: this.mcconnectLastUpdatedAt,
              msisdn : this.customerService.getPerson().phone_number     
            });
          },
          (err) => {  

                DetailsComponent.decrementRunningRequests(); 
                this.loaderService.display(false);

                if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                    });
                } 
                else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                    });
                }                
          },
          () => {              
              DetailsComponent.decrementRunningRequests();
              this.loaderService.display(false);
          });
  }

  /*showMSISDNupdateDialog() {
    this.ds.addDialog(MSISDNupdateComponent, {
      title: 'Msisdnupdate dialog', oldMsisdn: this.customerService.getPerson().phone_number,
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService
    });
  }*/

  showMailaddDialog(event) {    
    this.loseFocusOnButton(event,"btn-mailadd");

    this.ds.addDialog(MailaddComponent, {
      title: 'Mailadd dialog',
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService
    });
  }

  verifyMailPressed() {
    this.customerService.verifyMail(this.subValue, this.opcoValue, this.ds);
  }

  resetPinPressed(event) {
    this.loseFocusOnButton(event,"btn-resetpin");    
    if (this.opcoValue !== 'vo') {
      if(this.customerService.getPerson().email === null){
        this.ds.addDialog(NotificationDialogComponent, {
            success: false,
            message: this.translatePipe.transform("EMAIL_NOTPRESENT_EXCEPTION",'SHAREDCONSTANTS')
        });
      } else if(this.customerService.getPerson().email_verified === false){
        this.ds.addDialog(NotificationDialogComponent, {
            success: false,
            message: this.translatePipe.transform("EMAIL_NOTVERIFIED_EXCEPTION",'SHAREDCONSTANTS')
        });
      } else {
          //this.customerService.resetPasswordRequest(this.subValue, this.opcoValue, this.ds);
            this.ds.addDialog(ResetPinDialogComponent, {
              subValue: this.subValue,
              opcoValue: this.opcoValue,
              customerService: this.customerService
            });
      }
    }
    else{
      this.ds.addDialog(ResetPinDialogComponent, {
        subValue: this.subValue,
        opcoValue: this.opcoValue,
        customerService: this.customerService
      });
    }
    
  }

  resetPaswordPressed(event) {
    this.loseFocusOnButton(event,"btn-resetpassword");    
    if (this.opcoValue !== 'vo') {
      if(this.customerService.getPerson().email === null){
        this.ds.addDialog(NotificationDialogComponent, {
            success: false,
            message: this.translatePipe.transform("EMAIL_NOTPRESENT_EXCEPTION",'SHAREDCONSTANTS')
        });
      } else if(this.customerService.getPerson().email_verified === false){
        this.ds.addDialog(NotificationDialogComponent, {
            success: false,
            message: this.translatePipe.transform("EMAIL_NOTVERIFIED_EXCEPTION",'SHAREDCONSTANTS')
        });
      } else {
          //this.customerService.resetPasswordRequest(this.subValue, this.opcoValue, this.ds);
            this.ds.addDialog(ResetDialogComponent, {
              subValue: this.subValue,
              opcoValue: this.opcoValue,
              customerService: this.customerService
            });
      }
    }
    else{
      this.ds.addDialog(ResetDialogComponent, {
        subValue: this.subValue,
        opcoValue: this.opcoValue,
        customerService: this.customerService
      });
    }
    
  }

  activateAccountPressed(event) {
    this.loseFocusOnButton(event,"btn-activateaccount");    
    this.ds.addDialog(ActivateAccountDialogComponent, {
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService
    });
  }

  unlockAccountPressed(event) {
    this.loseFocusOnButton(event,"btn-resetUnlockAccount");
    this.ds.addDialog(UnlockAccountDialogComponent, {
      title: 'Unlock Customer Account',
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      previousData: this.customerService.getPerson(),
      customerService: this.customerService
    });
  }

  rememberMePressed(event){
    //this.rememberMeService.getAllRememberMeList(this.subValue, this.opcoValue);

    this.loseFocusOnButton(event,"btn-rememberme");

    this.ds.addDialog(RememberMeComponent, {
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      selectedCountry: this.selectedCountry,
      agentprofile: this.agentProfileService.loadAgentProfile(),
      rememberMeService: this.rememberMeService
    });
  }


  showGatewayHistoryConnectDialog(event){

    this.loseFocusOnButton(event,"btn-gateway");

    this.ds.addDialog(GatewayHistoryComponent, {
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      agentprofile: this.agentProfileService.loadAgentProfile()      
    });
  }

  showMobileConnectPerService(event){    

    this.loseFocusOnButton(event,"btn-mobile-connect-service");

    this.ds.addDialog(SuccessfullLogin, {
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      selectedCountry: this.selectedCountry,
      agentprofile: this.agentProfileService.loadAgentProfile(),
      lastLoginService: this.lastLoginService     
    });
  }

  //customerLogoutRequest
  logoutFromServicePressed(event) {
    this.loseFocusOnButton(event,"btn-logout");

    this.ds.addDialog(LogoutCustomerComponent, {
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      selectedCountry: this.selectedCountry,
      agentprofile: this.agentProfileService.loadAgentProfile(),
      rememberMeService: this.rememberMeService
    });

    //this.customerService.customerLogoutRequest(this.subValue, this.opcoValue, this.ds);
  }

  showUserUpdateDialog(event) {
    this.loseFocusOnButton(event,"btn-attributesupdate");

    if (this.customerService.getPerson().address === undefined) {
      this.customerService.getPerson().address = new Address();
    }
    this.ds.addDialog(CustomerUpdateDialogComponent, {
      title: 'User details dialog',
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      previousData: this.customerService.getPerson(),
      customerService: this.customerService
    });
  }


  showKYCHistory(event){
    this.loseFocusOnButton(event,"kycHistoryButtonId");
    this.ds.addDialog(KYCHistoryDialogComponent, {
      title: this.translatePipe.transform("KYC_MODAL_TITLE",'DETAILSVIEWLABELS'),
      subValue: this.subValue,
      opcoValue: this.opcoValue,
      customerService: this.customerService      
    });
  }

  showKYCDialog(event) {
    this.loseFocusOnButton(event,"kycUpdateButtonId");

    if (this.customerService.getKycData()) {
      const kycUpdatedata = new KycUpdateData();
      kycUpdatedata.status = this.customerService.getKycData().status;
      kycUpdatedata.external_reference_id = this.customerService.getKycData().external_reference_id;
      kycUpdatedata.external_reference_link = this.customerService.getKycData().external_reference_link;
      kycUpdatedata.fiscal_code = this.customerService.getKycData().fiscal_code;
      kycUpdatedata.nationality = this.customerService.getKycData().nationality;
      kycUpdatedata.personal_id = new PersonalId();

      if (this.customerService.getKycData().personal_id) {
        kycUpdatedata.personal_id.id_type = (this.customerService.getKycData().personal_id !== null && this.customerService.getKycData().personal_id.id_type !== null) ? this.customerService.getKycData().personal_id.id_type.toUpperCase() : "";
        kycUpdatedata.personal_id.id_number = (this.customerService.getKycData().personal_id !== null && this.customerService.getKycData().personal_id.id_number !== null) ? this.customerService.getKycData().personal_id.id_number : "";
        kycUpdatedata.personal_id.issue_date = (this.customerService.getKycData().personal_id !== null && this.customerService.getKycData().personal_id.issue_date !== null) ? this.customerService.getKycData().personal_id.issue_date : "";
        kycUpdatedata.personal_id.id_country = (this.customerService.getKycData().personal_id !== null && this.customerService.getKycData().personal_id.id_country !== null) ? this.customerService.getKycData().personal_id.id_country : "";
        kycUpdatedata.personal_id.expiration_date = (this.customerService.getKycData().personal_id !== null && this.customerService.getKycData().personal_id.expiration_date !== null) ? this.customerService.getKycData().personal_id.expiration_date : "";
      }

      // if (this.customerService.getKycData().personal_id) {
      //   kycUpdatedata.personal_id.id_type = this.customerService.getKycData().personal_id.id_type!=null ? this.customerService.getKycData().personal_id.id_type.toUpperCase() : "";
      //   kycUpdatedata.personal_id.id_number = this.customerService.getKycData().personal_id.id_number;
      //   kycUpdatedata.personal_id.issue_date = this.customerService.getKycData().personal_id.issue_date;
      //   kycUpdatedata.personal_id.id_country = this.customerService.getKycData().personal_id.id_country;
      //   kycUpdatedata.personal_id.expiration_date = this.customerService.getKycData().personal_id.expiration_date;
      // }
      kycUpdatedata.comment = '';
      this.ds.addDialog(KycUpdateDialogComponent, {
        title: 'KYC dialog',
        kycUpdateData: kycUpdatedata,
        personDetails: this.customerService.getPerson(),
        subValue: this.subValue,
        opcoValue: this.opcoValue,
        customerService: this.customerService
      });
    } else {
      const kycUpdatedata = new KycUpdateData();
      kycUpdatedata.personal_id = new PersonalId();
      this.ds.addDialog(KycUpdateDialogComponent, {
        title: 'KYC dialog',
        kycUpdateData: kycUpdatedata,
        personDetails: this.customerService.getPerson(),
        subValue: this.subValue,
        opcoValue: this.opcoValue,
        customerService: this.customerService
      });
    }
  }
  showKYCRevokeDialog(event) {
    this.loseFocusOnButton(event,"kycStatusRevokeButtonId");
      const kycUpdatedata = new KycUpdateData();
      kycUpdatedata.status = 'not-started';
      console.log(kycUpdatedata,'kycUpdatedata')
      //ycUpdatedata.personal_id = new PersonalId();
      this.ds.addDialog(KycRevokeDialogComponent, {
        title: 'KYC Revoke dialog',
        kycUpdateData: kycUpdatedata,
        subValue: this.subValue,
        opcoValue: this.opcoValue,
        customerService: this.customerService
      });
  }


  checkEmailEmpty() {
    if (!this.customerService.getPerson().email) {
      return true;
    }
    if (this.customerService.getPerson().email.trim() === '') {
      return true;
    }
    return false;
  }

  getBirthdateFormated(): string {
    if (this.customerService.getPerson().birthdate) {
      return this.customerService.getPerson().birthdate.replace(/\//g, '.');
    }
    return '';
  }

  removeGrantedApp(appId: string) {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_APP_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveGrantedApp(this.subValue, this.opcoValue, appId, this.ds);
        }        
    });
      
    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_APP_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveGrantedApp(this.subValue, this.opcoValue, appId, this.ds);
    // }
  }

  removeBlacklistedApp(appId: string) {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_APP_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveBlacklistedApp(this.subValue, this.opcoValue, appId, this.ds);
        }        
    });


    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_APP_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveBlacklistedApp(this.subValue, this.opcoValue, appId, this.ds);
    // }
  }
  kycCompletnessInofrmationalNotes(){
       this.ds.addDialog(KYCINFODialogComponent, {
      title: 'Mailupdate dialog',
      message:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')
    });
  }
  removeBannedApp(appId: string) {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_APP_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveBannedApp(this.subValue, this.opcoValue, appId, this.ds);
        }        
    });

    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_APP_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveBannedApp(this.subValue, this.opcoValue, appId, this.ds);
    // }
  }

  removeAllAppsTokens() {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_ALL_APPS_TOKENS_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveAllAppsTokens(this.subValue, this.opcoValue, this.ds);
        }        
    });

    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_ALL_APPS_TOKENS_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveAllAppsTokens(this.subValue, this.opcoValue, this.ds);
    // }
  }

  removeAllGrantedApps() {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveAllGrantedApps(this.subValue, this.opcoValue, this.ds);
        }        
    });

    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveAllGrantedApps(this.subValue, this.opcoValue, this.ds);
    // }
  }

  removeAllBlacklistedApps() {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveAllBlacklistedApp(this.subValue, this.opcoValue, this.ds);
        }        
    });

    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveAllBlacklistedApp(this.subValue, this.opcoValue, this.ds);
    // }
  }

  removeAllBannedApps() {

    this.ds.addDialog(DeleteCofirmationDialogComponent, {
      title:this.translatePipe.transform("CONFIRMATION_TITLE",'SEARCHVIEWLABELS'),
      message:this.translatePipe.transform("SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE",'DETAILSVIEWLABELS'),
      okButtonLabel:this.translatePipe.transform("OK_BUTTON_LABEL",'SHAREDCONSTANTS'),
      cancelButtonLabel:this.translatePipe.transform("CANCEL_BUTTON_LABEL",'SHAREDCONSTANTS')})
      .subscribe((isConfirmed)=>{
        //Get dialog result
        if(isConfirmed){
          this.consentService.RemoveAllBannendApp(this.subValue, this.opcoValue, this.ds);
        }        
    });

    // if (confirm(DETAILSVIEWLABELS.SERVICE_REMOVE_ALL_APPS_CONFIRM_MESSAGE)) {
    //   this.consentService.RemoveAllBannendApp(this.subValue, this.opcoValue, this.ds);
    // }
  }


  loseFocusOnButton(event,id){
    event.stopPropagation();
    document.getElementById(id).blur();
    
  }
  

  showDetails(id){
    let wrap = document.getElementById("wrap");
    const searchBtn = (document.getElementById('searchSubmitButtonId') as HTMLInputElement);
    searchBtn.disabled = true;
    searchBtn.classList.remove('primary');
    searchBtn.classList.add('secondary');
    
    setTimeout(() => {
      searchBtn.disabled = false;
      searchBtn.classList.remove('secondary');
      searchBtn.classList.add('primary');
    }, 15000);
    wrap.innerHTML="";
   this.consentService.findDetail(id,this.opcoValue).subscribe(
    (data) => { 
    // console.log(data,'data')
    this.detailData= data;
    if(this.detailData!=0){
    this.renderJSON();
    this.bindEvents();
    }
    },
    err => { 
      this.detailData=[];
    }
   );
   }

    renderJSON(){
    //  console.log(this.detailData,'detailsData');
       var wrap = document.getElementById("wrap");
       wrap.innerHTML="";
       wrap.setAttribute("class", "json-ui-wrap");
       let jsonUI = document.createElement('div');
       jsonUI.setAttribute("class", "json-ui");
       let ul = document.createElement('ul');
       ul.setAttribute("class", "json-ol-ul ");
       let items = [];
       for( let entity in this.detailData ){
           let entryHeading = document.createElement('div');
           entryHeading.setAttribute("class", "entry-heading");

           let entryHeadingTitle = document.createElement('div');
           entryHeadingTitle.setAttribute("class", "entry-heading-title");

           let entryHeadingDetails = document.createElement('ul');
           entryHeadingDetails.setAttribute("class", "entry-heading-details");

           let li = document.createElement('li');
          li.setAttribute("style", " border-bottom:1px solid black");
           let item = this.detailData[entity];

           if( item["roleType"] === "Explicit" ){

               entryHeadingTitle.innerHTML = item["entityClass"] + ": " + item["entityId"];
               entryHeading.appendChild(entryHeadingTitle);
               // entryHeadingDetails.innerHTML = "<code>" + JSON.stringify(item) + "</code>";

//               console.log(item);

               this.organizeJSON( entryHeadingDetails, item ,false);

               entryHeading.appendChild(entryHeadingDetails);

               li.appendChild(entryHeading);
               ul.appendChild(li);

               this.findChild( item["entityId"], li );
           }

       }
//console.log('error')
   jsonUI.appendChild(ul);
       wrap.appendChild(jsonUI);
   }

    findChild( entityId, entry ){

       let ul = document.createElement('ul');
       ul.setAttribute("class", "json-ol-ul ");
       for( let entity in this.detailData ){
           let entryHeading = document.createElement('div');
           entryHeading.setAttribute("class", "entry-heading");

           let entryHeadingTitle = document.createElement('div');
           entryHeadingTitle.setAttribute("class", "entry-heading-title");

           let entryHeadingDetails = document.createElement('div');
           entryHeadingDetails.setAttribute("class", "entry-heading-details");

           let li = document.createElement('li');
           //li.setAttribute("class", "json-ol-ul ");
           let item = this.detailData[entity];

           if( item["parentEntityId"] === entityId ){

               entryHeadingTitle.innerHTML = item["entityClass"] + ": " + item["entityId"];
               entryHeading.appendChild(entryHeadingTitle);
               // entryHeadingDetails.innerHTML = "<code>" + JSON.stringify(item) + "</code>";

  //             console.log(item);

               this.organizeJSON( entryHeadingDetails, item,false );

               entryHeading.appendChild(entryHeadingDetails);

               li.appendChild(entryHeading);
               ul.appendChild(li);

               entry.appendChild(ul);
               entry.setAttribute("class", "list");
               ul.setAttribute("class", "expandable");

               this.findChild( item["entityId"], li );
           }

       }
   }

    toggleEntry( entry ){
       let entryHeadingClassName = entry.getAttribute("class");

       if( entryHeadingClassName.indexOf("selected") != -1 ){
           entry.setAttribute("class", "entry-heading");
       }else{
           entry.setAttribute("class", entryHeadingClassName + " selected");
       }

       if( entry.nextSibling ){
           let expandableClassName = entry.nextSibling.getAttribute("class");

           if( expandableClassName.indexOf("expanded") != -1 ){
               entry.nextSibling.setAttribute("class", "expandable");   
           }else{
               entry.nextSibling.setAttribute("class", expandableClassName + " expanded");
           }
       }
   }

    organizeJSON( target, item, parent ){
      for (var key in item) {
               if (item.hasOwnProperty(key)) {
                  if(item[key]!=null && typeof item[key] === 'object'){
                    this.entityClass=key;
                  }
               }
              }
       for (var key in item) {
    
           if (item.hasOwnProperty(key)) {
               
               let ul = document.createElement('ul');
               let li = document.createElement('li');
               ul.setAttribute("class", "json-ol-ul ");
              if(item[key]!=null)
              {
              if( typeof item[key] === 'object'){
                   li.innerHTML = key + ": ";

                   if( parent ){
                       parent.appendChild(li);
                   }else{
                       target.appendChild(li);
                   }

                   this.organizeJSON( li, item[key], ul );
                
               }
              
               else{
                 
                if(key=="entityClass"){
                  li.innerHTML = key + ": "+this.entityClass;
                }
                else{
                  li.innerHTML = key + ": "+item[key];
                  }
                 
                   if( parent ){
                       parent.appendChild(li);
                   }else{
                       target.appendChild(li);
                   }

                   if( parent ){
                   target.appendChild(parent);
               }   
               }
              }
           }
       }

   }

  checkExceptionalOpco() {
    if(this.opcoValue === 'ro' || this.opcoValue === 'vo' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it') {
      return true;
    }
    return false;
  }
   
   bindEvents(){
      var page=this;
    //  console.log(this,'page')
       var headings = document.getElementsByClassName("entry-heading");
       var headingsDetails = document.getElementsByClassName("entry-heading-details");

       for( var i = 0; i < headings.length; i++ ){
           headings[i].addEventListener("click", function(e) {
             page.toggleEntry(this);
           });
       }

       for( var i = 0; i < headingsDetails.length; i++ ){
           headingsDetails[i].addEventListener("click", function(e) {

               e.stopPropagation();

           });
       }
   }

    onScroll(){
      var scrollContainer = document.getElementById("wrap");
      var scrollContainerOffsetTop = scrollContainer.getBoundingClientRect().top;
      var scrollContainerOffsetLeft = scrollContainer.getBoundingClientRect().left;
      var scrollContainerOffsetWidth = scrollContainer.getBoundingClientRect().width;
      var headings ;
            headings = document.getElementsByClassName("entry-heading");

            for (let heading of headings) {
                if( heading.getAttribute("class").indexOf("selected") > -1 ){

                    var box = heading.getBoundingClientRect();
                    var boxTop = box.top - scrollContainerOffsetTop;
                    if( boxTop < 0 ){
                        heading.setAttribute("class", "entry-heading selected sticky");

                        heading.childNodes[0].style.top = (scrollContainerOffsetTop + 1 + "px"); // + 1 considering wrap border
                        heading.childNodes[0].style.left = (scrollContainerOffsetLeft + 1 + "px"); // + 1 considering wrap border
                        heading.childNodes[0].style.width = (scrollContainerOffsetWidth - 2 + "px"); // - 2 considering wrap border
                    }else{
                        heading.setAttribute("class", "entry-heading selected");
                    }
                }
            }
        }
 

}



// WEBPACK FOOTER //
// ./src/app/details/details.component.ts